import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  type ConversionTrackingClient,
  type IntegrationClient,
} from "@fitness-app/data-models/entities/ProductsSettings";
import { getError, getErrorMessage } from "@fitness-app/utils";

import { type ActionParams, type AsyncThunkCreator } from "../../../index";
import { PRODUCTS_SETTINGS_REDUCER_NAME } from "../types";

export type Payload = {
  id: string;
  client: IntegrationClient | ConversionTrackingClient;
};

export const removeIntegrationWithExternalApi = createAsyncThunk<
  void,
  ActionParams<Payload>,
  AsyncThunkCreator<string>
>(
  `${PRODUCTS_SETTINGS_REDUCER_NAME}/removeIntegrationWithExternalApi`,
  async ({ onSuccess, onFailure, payload }, { rejectWithValue, extra: { integrationApi, analytics } }) => {
    try {
      await integrationApi.post("/remove-integration-with-external-api", payload);

      analytics.track("remove-integration-with-external-api", {
        client: payload.client,
      });
      onSuccess?.();
    } catch (e) {
      onFailure?.(getError(e).status);

      return rejectWithValue(getErrorMessage(e));
    }
  },
);
